import { PrismicNextImage } from '@prismicio/next';
import TransitionLink from '@/components/TransitionLink';
import type { BlogCard } from '@/lib/blog-cards';

/** Thumbnail card (1440:1042, matching the blog featured image) used by Latest, the format sections and category pages. Styles: blog-home.css. */
export default function PostCard({ post, archiveBadge }: { post: BlogCard; archiveBadge?: string }) {
  return (
    <article className="card">
      <TransitionLink href={post.href} tabIndex={-1} aria-hidden className="thumb">
        {post.image.url && (
          <PrismicNextImage
            field={post.image}
            fallbackAlt=""
            sizes="(min-width: 1000px) 400px, (min-width: 640px) 50vw, 100vw"
          />
        )}
      </TransitionLink>
      <div className="m">
        <b>{post.formatLabel}</b>
        {post.industryLabel && (
          <>
            <span className="dot" />
            <i>{post.industryLabel}</i>
          </>
        )}
        <span className="dot" />
        {post.readLabel}
      </div>
      <h3>
        <TransitionLink href={post.href}>{post.title}</TransitionLink>
        {archiveBadge && post.archived && <span className="ar">{archiveBadge}</span>}
      </h3>
      {post.excerpt && <p>{post.excerpt}</p>}
    </article>
  );
}
